import Component from '../app/component'
import ImagesParallax from '../plugins/images-parallax.js'
import Player from "@vimeo/player";


export default class AboutComponent extends Component {
  constructor (el) {
    super(el)
    this.data = {}
  }

  init () {
    new ImagesParallax(this.refs.images)

    const videoContainer = this.el.querySelector('.cm-about-video__video')

    if (videoContainer) {
      const player = new Player(videoContainer, {
        id: videoContainer.dataset.id,
        background: false,
        autoplay: false,
        muted: false,
        loop: false,
        dnt: true,
        fullscreen: true
      })

      const thumb = videoContainer.querySelector('.cm-about-video__thumb')
      if (thumb) {
        player.ready().then(() => thumb.remove())
      }
    }
  }
}
